import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { MultiItemStore } from 'stores/multi-item-store';

import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkSpacing } from 'uitk-react-spacing';

import { PropertySummaryHeader } from './property-summary-header';
import { SharedUiPropertySearchLinkWrapper } from 'components/infosite/shared-ui/offers/property-search-link-wrapper';
import { SharedUiSaveTripItemWrapper } from './shared-ui/details/save-trip-item-wrapper';
import { SharedUiShortlistWrapper } from './shared-ui/details/shortlist-wrapper';
import { SharedUiStickyPriceHeaderWrapper } from './shared-ui/offers/shared-ui-property-sticky-price-header-wrapper';

interface PropertySummaryBackLinkWrapperProps {
  regionId?: string;
  currentHotel?: CurrentHotelStore;
  navigateTabs?: () => any;
  multiItem?: MultiItemStore;
}

export type LocalizedPropertySummaryBackLinkWrapperProps = LocalizedComponentProps & PropertySummaryBackLinkWrapperProps;

@withLocalization
@inject('currentHotel', 'multiItem')
@observer
export class PropertySummaryBackLinkWrapper extends React.Component<LocalizedPropertySummaryBackLinkWrapperProps> {
  public render() {
    const { currentHotel, multiItem, l10n } = this.props;
    const searchCriteria = currentHotel?.searchCriteria;
    const regionId = searchCriteria?.regionId;
    const startDate = searchCriteria?.startDate;
    const endDate = searchCriteria?.endDate;
    const isDateLess = searchCriteria?.isDateless;
    const isMultiItem = multiItem?.cartInfo?.id ?? multiItem?.isPackageShoppingPath();

    const cardContent = (viewLarge = false) => (
      <div>
        <UitkLayoutFlex alignItems="center">
          <UitkLayoutFlexItem grow={1}>
            <div>
              <SharedUiPropertySearchLinkWrapper />
            </div>
          </UitkLayoutFlexItem>

          {!isDateLess && viewLarge && !isMultiItem && (
            <Experiment name="Price_Summary_above_the_scroll_line_on_PDP">
              <ExperimentControl />
              <ExperimentVariant bucket={1}>
                <UitkLayoutFlexItem>
                  <SharedUiStickyPriceHeaderWrapper hideCtaButton={true} wrapPriceSummary />
                </UitkLayoutFlexItem>
              </ExperimentVariant>
              <ExperimentVariant bucket={2}>
                <UitkLayoutFlexItem>
                  <SharedUiStickyPriceHeaderWrapper wrapPriceSummary />
                </UitkLayoutFlexItem>
              </ExperimentVariant>
            </Experiment>
          )}

          <div data-stid="favorite-save-button">
            <SharedUiShortlistWrapper />
            <SharedUiSaveTripItemWrapper />
          </div>
        </UitkLayoutFlex>
      </div>
    );

    return (
      <UitkLayoutFlexItem>
        <Viewport>
          <ViewSmall>
            <>
              <UitkSpacing padding={{ inline: 'two', blockend: 'two' }}>
                <div>
                  <PropertySummaryHeader l10n={l10n} multiItem={multiItem} regionId={regionId} startDate={startDate} endDate={endDate} />
                </div>
              </UitkSpacing>
              <UitkCard className="uitk-flat-border-top uitk-flat-border-bottom" overflow={true}>
                <UitkCardContentSection padded={false}>
                  <UitkSpacing padding={{ block: 'one', inline: 'two' }}>{cardContent(false)}</UitkSpacing>
                </UitkCardContentSection>
              </UitkCard>
            </>
          </ViewSmall>
          <ViewLarge>
            <UitkCard className="uitk-flat-border-top uitk-flat-border-bottom" overflow={true}>
              <UitkCardContentSection padded={false}>
                <UitkSpacing padding={{ inline: 'two' }} margin={{ blockstart: 'three' }}>
                  <div>
                    <PropertySummaryHeader l10n={l10n} multiItem={multiItem} regionId={regionId} startDate={startDate} endDate={endDate} />
                  </div>
                </UitkSpacing>
                <UitkSpacing padding={{ block: 'two', inline: 'two' }}>{cardContent(true)}</UitkSpacing>
              </UitkCardContentSection>
            </UitkCard>
          </ViewLarge>
        </Viewport>
      </UitkLayoutFlexItem>
    );
  }
}
